import axios from 'axios';

const API = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || '').replace(/\/$/, ''),
});

function authHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function listAllSlabs() {
  try {
    const url = '/admin/price-slabs';
    const res = await API.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    const status = err?.response?.status;
    console.error('PriceSlabService.listAllSlabs error', err?.response?.status, err?.response?.data || err.message);

    // Fallback: try dev-server proxied path if axios baseURL misconfiguration causes 404
    if (status === 404) {
      try {
        const proxied = await axios.get('/api/admin/price-slabs', { headers: authHeader() });
        return proxied.data;
      } catch (e) {
        const s2 = e?.response?.status;
        // If proxied call also indicates not found, return empty
        if (s2 === 404) return [];
        // If proxied call is unauthorized, rethrow so caller can redirect to login
        if (s2 === 401) throw e;
        throw e;
      }
    }

    // If unauthorized, rethrow so caller can handle auth (redirect to login)
    if (status === 401) throw err;
    throw err;
  }
}

export async function listSlabsByProduct(productId) {
  const res = await API.get(`/product-price-slabs/product/${productId}`);
  return res.data;
}

export async function createSlab({ productId, minQty, price }) {
  const res = await API.post(
    '/admin/price-slabs',
    { productId, minQty, price },
    { headers: authHeader() }
  );
  return res.data;
}

export async function updateSlab(id, { minQty, price }) {
  const res = await API.put(
    `/admin/price-slabs/${id}`,
    { minQty, price },
    { headers: authHeader() }
  );
  return res.data;
}

export async function deleteSlab(id) {
  const res = await API.delete(`/admin/price-slabs/${id}`, { headers: authHeader() });
  return res.data;
}
